<template>
  <div v-if="orderInfo">
    <el-descriptions border :column="2">
      <el-descriptions-item label="订单号">{{ orderInfo.order_sn }}</el-descriptions-item>
      <el-descriptions-item label="订单状态">
        <el-tag :type="getTagType(orderInfo.order_status)">
          {{ orderInfo.status_text }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="用户ID">{{ orderInfo.user_id }}</el-descriptions-item>
      <el-descriptions-item label="会员邮箱">{{ orderInfo.email }}</el-descriptions-item>
      <el-descriptions-item label="下单时间">{{ orderInfo.create_time }}</el-descriptions-item>
      <el-descriptions-item label="用户备注">{{ orderInfo.user_mark || '无' }}</el-descriptions-item>
      <el-descriptions-item label="订单金额" span="2">
        <span style="color:#f56c6c;font-size:18px;">人民币 {{ orderInfo.actual_pay_price/100 }} 元</span>
      </el-descriptions-item>

       <el-descriptions-item label="商家回复">
        <quill-editor ref="myQuillEditor" v-model="orderInfo.remark" :options="editorOptions"></quill-editor>
        <el-button style="margin-top: 10px;" type="primary" plain @click="save_admin_remark">保存</el-button>
      </el-descriptions-item>

    </el-descriptions>

    <div style="margin-top:24px;">
      <h4>商品清单</h4>
      <el-table :data="orderInfo.product_list" border style="width:100%">
        <el-table-column label="商品图片" width="110">
          <template slot-scope="scope">
            <img :src="trans_cover(scope.row.product_cover)" style="width:90px;height:90px;" fit="cover"/>
          </template>
        </el-table-column>
        <el-table-column label="商品名称">
          <template slot-scope="scope">
            <div>{{ parseMultiLang(scope.row.goods_name) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="规格名称">
          <template slot-scope="scope">
                <div>{{ lang_auto_trans(scope.row.product_name,'') }}</div>
          </template>
        </el-table-column>
        <el-table-column label="单价" width="100">
          <template slot-scope="scope">¥{{scope.row.price/100}}</template>
        </el-table-column>
        <el-table-column label="数量" prop="number" width="80"></el-table-column>
      </el-table>
    </div>

     <photo-center :photoCenterShow="photoCenterShow" :maxselected_num="maxselected_num" @closeDialog="closePhotoCenter"></photo-center>
  </div>
</template>

<script>

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import PhotoCenter from "../../components/PhotoCenter/PhotoCenter.vue";

import { baseURL, order_reply} from '../../api/api';
import { event_msg_keys } from '../../eventbus/eventkeys';
import { lang_auto_trans } from '../../utils';
import { quillEditor } from "vue-quill-editor";

export default {
    components:{
        quillEditor,
        PhotoCenter
    },
  props: {
    orderInfo:
    {
        type:Object,
		default:null
    }
  },
  data(){
    return {
       lang_auto_trans,
       photoCenterShow:false,
       maxselected_num:999,
       baseURL,
       editorOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean'],
              ['link', 'image', 'video']
            ],
            handlers: {
              image: this.imageHandler // 重写图片处理函数
            }
          }
        }
      }
    }
  },
  watch: {
    
  },
  mounted(){
     this.$evt.on(event_msg_keys.img_selected_submit_noti,this.img_selected_submit_callback)
  },
   destroyed(){
    this.$evt.off(event_msg_keys.img_selected_submit_noti,this.img_selected_submit_callback)
  },
  methods: {

    trans_cover(cover){
       return cover.startsWith('/')?`${baseURL}${cover}`:cover.startsWith('http')?`${cover}`:`${baseURL}/${cover}`
    },
    async save_admin_remark(){
        console.log('save_admin_remark',this.orderInfo.remark,this.orderInfo.order_sn)

        try {
            await order_reply({order_sn:this.orderInfo.order_sn,remark:this.orderInfo.remark})
            this.$message({
                type: "success",
                message:'保存成功'
            })
            
        } catch (error) {
             this.$message({
                type: "error",
                message:error
            })
        }

    },
    img_selected_submit_callback(e){
     const selected_imgs = e.imgs
     const pics_array = selected_imgs.map(item => item.source)
     this.fillEditorImage(pics_array);
    },

    closePhotoCenter(){
      this.photoCenterShow = false;
    },
    imageHandler(){
      this.photoCenterShow = true;
      this.maxselected_num = 999;
    },

    // 上传图片
    async fillEditorImage(pics) {
  
      if (!pics.length) return
      
      const quill = this.$refs.myQuillEditor.quill
      const range = quill.getSelection()
      const index = range ? range.index : 0
      
      try {
        
        pics.forEach((pic,i) => {
          const url = pic.startsWith('/')?`${this.baseURL}${pic}?q=30`:pic.startsWith('http')?`${pic}?q=30`:`${this.baseURL}/${pic}?q=30`
    
          quill.insertEmbed(index+i, 'image', url) // 假设返回{url: '图片地址'}
        });
        
      
      } catch (error) {
        console.log('插入失败', error)
      
      } finally {
        // 清空input，允许重复选择同一文件
        // e.target.value = ''
      }
    },

    getTagType(status) {
      const map = {0:'warning',1:'info',2:'success',3:'primary',4:'success'}
      return map[status]
    },
    // 解析多语言json字符串 goods_name
    parseMultiLang(jsonStr) {
      try{
        const obj = JSON.parse(jsonStr)
        // 默认取中文key "1"，你可以根据当前系统语言切换
        return obj["1"] || Object.values(obj)[0]
      }catch{
        return jsonStr
      }
    }
  }
}
</script>